<template>
    <div>
        <div v-if="edit" class="d-flex flex-column gap-1">
            <input class="form-control form-control-sm"
                   type="text"
                   v-model="form.name"
                   :disabled="!editable"
                   :placeholder="__('general.name')"
            />
            <input class="form-control form-control-sm"
                   type="text"
                   v-model="form.street1"
                   :disabled="!editable"
                   :placeholder="__('general.street')"
            />
            <input class="form-control form-control-sm"
                   type="text"
                   v-model="form.street2"
                   :disabled="!editable"
                   :placeholder="__('store.street2')"
            />
            <div class="row no-gutters">
                <div class="col-md-6">
                    <input class="form-control form-control-sm"
                           type="text"
                           v-model="form.postcode"
                           :disabled="!editable"
                           :placeholder="__('general.postcode')"
                    />
                </div>
                <div class="col-md-6 pl-1">
                    <input class="form-control form-control-sm"
                           type="text"
                           v-model="form.city"
                           :disabled="!editable"
                           :placeholder="__('general.city')"
                    />
                </div>
            </div>
            <input class="form-control form-control-sm"
                   type="text"
                   v-model="form.state"
                   :disabled="!editable"
                   :placeholder="__('general.state')"
            />
            <select class="form-control form-control-sm" v-model="form.country_code" :disabled="!editable">
                <option disabled>{{ __('actions.select_thing', {thing: __('general.country')}) }}</option>
                <option value="us">{{ __('countries.with_flag.us') }}</option>
                <option value="uk">{{ __('countries.with_flag.uk') }}</option>
                <option value="de">{{ __('countries.with_flag.de') }}</option>
                <option value="at">{{ __('countries.with_flag.at') }}</option>
                <option value="fr">{{ __('countries.with_flag.fr') }}</option>
            </select>
        </div>
        <div v-else>
            <span class="font-weight-bold font-size-lg">{{ form.name }}</span><br>
            <span>{{ form.street1 }}</span><br>
            <span v-if="form.street2">{{ form.street2 }}<br></span>
            <span>{{ form.postcode }}&nbsp;{{ form.city }}<br></span>
            <span v-if="form.state">{{ form.state }}<br></span>
            <span v-if="form.country_code" class="text-uppercase font-size-sm font-weight-bold">
                {{ __('countries.with_flag.' + form.country_code.toLowerCase()) }}
            </span>
        </div>

        <div v-if="edit" class="mt-3">
            <button class="btn btn-xs px-10 btn-light-primary" :disabled="!form.isDirty" @click="saveChanges">
                <i class="fas fa-save"/>
                {{ __('actions.submit') }}
            </button>
            <button class="btn btn-xs btn-light-danger" @click="edit = false">
                <i class="fas fa-times"/>
                {{ __('actions.abort') }}
            </button>
        </div>
        <div v-else-if="editable" class="mt-3">
            <button class="btn btn-xs btn-default btn-hover-primary" @click="edit = !edit">
                <i class="fas fa-edit"/>
                {{ __('actions.edit_thing', {thing: __('general.address.address')}) }}
            </button>
        </div>
    </div>
</template>

<script>
import FormGroupNew from "@components/Form/FormGroupNew.vue";

export default {
    components: {FormGroupNew},

    props: {
        order: Object,
        address: {
            type: Object,
            required: true,
            default() {
                return {
                    name: '',
                    street1: '',
                    street2: '',
                    postcode: '',
                    city: '',
                    state: '',
                    country_code: '',
                }
            }
        },
        editable: Boolean
    },

    data() {
        return {
            edit: false,
            form: this.$inertia.form(this.address)
        };
    },

    methods: {
        saveChanges() {
            if (!this.editable) {
                console.warn("The address may not be changed.")
                return;
            }

            let data = this.form.data();
            data.type = this.addressType;

            axios.patch(this.$route('ajax.orders.address.update', [this.order.store_uuid, this.order.url_key]), data)
                .then(response => {
                    if (response.status === 200) {
                        toastr.success(response.data.message);
                        this.edit = false;
                    }
                })
                .catch(error => {
                    toastr.error(error.response.data.error_message ?? __('general.unknown_error'))
                })
        },
    },

    computed: {
        addressType() {
            return this.address.pivot.type;
        },
    }
}
</script>
